import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';
import { MessageTemplate, RequestType } from '../Enum/common.enum';

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-fax-File',
  templateUrl: './fax-File.component.html',
  styleUrls: ['./fax-File.component.scss']
})

export class FaxFileComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;


  contactsList: any = [];
  peoples: any = [];
  showAddButton = false;
  Module: string;

  closeShare: boolean = false;
  @Input() mainModuleName: string;
  @Output() closeShareFile = new EventEmitter<boolean>();
  clickEventsubscription: any;
  selectedFileList: any = [];
  timeout = null;
  subject: string = "";
  message: string = "";
  replyFaxNumber: string = "";
  fileManagerIDs: any[];
  contacts: any;
  FileList: any[];
  UserList: any = [];

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  roleInputCurrentvalue: any;
  stateCtrSendlValue: any;

  stateCtrlValue: string;
  objectList: any = [];
  contactFax: any;
  transactionID: any;
  addButtonShow: boolean = false;
  anonymousFax: any = [] = [];
  spinner:boolean=false;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinnerTemp:boolean=false;

  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;

  constructor(private loaderService: LoaderService,private cdr: ChangeDetectorRef,private _dataSharingService: DataSharingService,
    private router: Router,private reusableClass: ReusableClasses,private encryptionAlgo: EncryptionService,
    private statusConst: StatusConstant,private settingsService: SettingService,private toastr: ToastrService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice())));
  }

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.mainModuleName;
  }


  ngOnInit(): void {
    this.mainModuleName;
    this.clickEventsubscription = this._dataSharingService.getSelectedRequestDocumentForCore().subscribe((result) => {
      if (result) {
        this.mainModuleName;
        this.selectedFileList = result;
        this.showAddButton = false;
        this.stateCtrlSubject.reset();
        this.ShowSubjectMessageButton=false;
        this.MessageTemplateID=0;
      }
    });

    this.clickEventsubscription = this._dataSharingService.getSelectedRequestDocumentForContact().subscribe((result) => {
      if (result) {
        this.mainModuleName;
        this.selectedFileList = result;
        this.showAddButton = false;
        this.stateCtrlSubject.reset();
        this.ShowSubjectMessageButton=false;
        this.MessageTemplateID=0;
      }
    });

    this.clickEventsubscription = this._dataSharingService.getSelectedRequestDocumentForCompany().subscribe((result) => {
      if (result) {
        this.mainModuleName;
        this.selectedFileList = result;
        this.showAddButton = false;
        this.stateCtrlSubject.reset();
        this.ShowSubjectMessageButton=false;
        this.MessageTemplateID=0;
      }
    });

    this.clickEventsubscription = this._dataSharingService.getSelectedFaxDocumentForFileManager().subscribe((result) => {
      if (result) {
        this.mainModuleName;
        this.selectedFileList = result;
        this.showAddButton = false;
        this.stateCtrlSubject.reset();
        this.ShowSubjectMessageButton=false;
        this.MessageTemplateID=0;
      }
    });
  }

  closeShareOpt(message: boolean) {
    this.showAddButton = false;
    this.peoples = [];
    this.message="";
    this.stateCtrl.reset();
    this.contactsList=[];
    this.closeShareFile.emit(message);
  }

  cancelShareOpt(message: boolean) {
    this.showAddButton = false;
    this.peoples = [];
    this.contactsList=[];
    this.closeShareFile.emit(message);
    this.subject = "";
    this.message = "";
    this.replyFaxNumber = "";
    this.stateCtrl.reset();
    this.stateCtrlSubject.reset();
    this.MessageTemplateID=0;
    if (this.mainModuleName == "Core") {
      this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
    }
    if (this.mainModuleName == "Contact") {
      this._dataSharingService.sendClosePanelFromDocDetailsContact(true);
    }
    if (this.mainModuleName == "Company") {
      this._dataSharingService.sendClosePanelFromDocDetailsCompany(true);
    }
    if (this.mainModuleName == "File Manager") {
      this._dataSharingService.sendClosePanelFaxForFileManager(true);
    }
  }

  getplaceholdername(placeholdername) {
    if(placeholdername!=null && placeholdername!=undefined){
      var x = placeholdername;
      var f = x.replace(/\..+$/, '');
      return f;
    }   
  }

  searchUser(val) {
    this.contactsList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getContactListFileManagerImplementation(val)
      }, 500);
    } else {
      this.contactsList = [];
    }
  }

  getContactListFileManagerImplementation(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      searchValue: searchValue,
      PageSize: 0,
    }
    this.settingsService.GetContactListFileManagerImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });

          const re = /^[0-9]{1,10}$/g;
          var check = re.test(String(searchValue).toLowerCase());

          if (check == true) {
            var ReqModel = {
              contactID: 0,
              fax: searchValue,
              img: "",
              name: "",
              shortName: ""
            }
            this.contactFax = searchValue;
            this.anonymousFax = [];
            this.anonymousFax.push(ReqModel);
            this.addButtonShow = true;
          }
          if (check == false) {
            this.anonymousFax = [];
            this.addButtonShow = false;
          }
        } else {
          this.contactsList = [];
        }
      }
    });
  }

  addcontact() {
    var findContact = this.peoples.filter((x) => x.fax === this.contactFax);
    if (findContact.length != undefined && findContact.length > 0) {
      let user = this.peoples.find(m => m.fax == findContact[0].fax);
      if (user = undefined || user == '' || user == null) {
        var req = {
          contactID: findContact[0].contactID,
          fax: findContact[0].fax,
          name: "",
          img: "",
          shortName: ""
        }
        this.peoples.unshift(req);
        this.stateCtrl.reset();
        this.addButtonShow = false;
        if (this.peoples.length > 0) {
          this.showAddButton = true;
        }
        else {
          this.showAddButton = false;
        }
      } else {
        this.addButtonShow = false;
        this.stateCtrl.reset();
        if (this.peoples.length > 0) {
          this.showAddButton = true;
        }
        else {
          this.addButtonShow = false;
          this.showAddButton = false;
        }
      }
    } else {
      var shortname = this.anonymousFax[0].fax.substring(0, 1)
      var reqmail = {
        contactID: "",
        fax: this.anonymousFax[0].fax,
        name: "",
        img: "",
        shortName: shortname
      }
      this.peoples.unshift(reqmail);
      this.stateCtrl.reset();
      if (this.peoples.length > 0) {
        this.showAddButton = true;
        this.addButtonShow = false;
      }
      else {
        this.showAddButton = false;
      }
    }
  }


  onEnter(event, contact) {
    this.addButtonShow = false;
    if (event.target.value == event.target.value.match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.contactFax = event.target.value;
      let user = this.peoples.find(m => m.fax == this.contactFax);
      if (user == undefined || user == '' || user == null) {
        var shortname = event.target.value.substring(0, 1)
        var ReqModel = {
          contactID: 0,
          fax: this.contactFax,
          img: "",
          name: "",
          shortName: shortname
        }
        this.peoples.unshift(ReqModel);
        this.stateCtrl.reset();
        if (this.peoples.length > 0) {
          this.showAddButton = true;
        }
        else {
          this.showAddButton = false;
        }
      } else {
        this.stateCtrl.reset();
      }
    } else {
      var findContact = this.contactsList.filter((x) => x.name === event.target.value);
      if (findContact.length != undefined && findContact.length > 0) {
        let user = this.peoples.find(m => m.contactID == findContact[0].contactID);
        if (user == undefined || user == '' || user == null) {
          var req = {
            contactID: findContact[0].contactID,
            fax: findContact[0].fax,
            name: findContact[0].name,
            img: findContact[0].imageUrl,
            shortName: findContact[0].shortName
          }
          if(findContact[0].fax== undefined || findContact[0].fax == '' || findContact[0].fax == null){
            this.stateCtrl.reset();
            this.addButtonShow = false;
            this.toastr.warning('Selected contact is not added fax number.', '', {
              timeOut: 3000,
            });
            return false;
          }
          this.peoples.unshift(req);
          this.stateCtrl.reset();
          if (this.peoples.length > 0) {
            this.showAddButton = true;
          }
          else {
            this.showAddButton = false;
          }
        } else {
          this.stateCtrl.reset();
          if (this.peoples.length > 0) {
            this.showAddButton = true;
            this.addButtonShow = false;
          }
          else {
            this.showAddButton = false;
          }
        }
      }
    }

  }

  contactSelected(contactSelected: any) {
    let user = this.peoples.find(m => m.contactID == contactSelected.contactID);
    if (user == undefined || user == '' || user == null) {
      if (contactSelected.contactID == 0) {
        return;
      }
      var ReqModel = {
        contactID: contactSelected.contactID,
        fax: contactSelected.fax,
        name: contactSelected.name,
        img: contactSelected.imageUrl,
        shortName: contactSelected.shortName,
      }

      if(contactSelected.fax== undefined || contactSelected.fax == '' || contactSelected.fax == null){
        this.stateCtrl.reset();
        this.addButtonShow = false;
        this.toastr.warning('Selected contact is not added fax number.', '', {
          timeOut: 3000,
        });
        return false;
      }

      this.peoples.unshift(ReqModel);     
      this.stateCtrl.reset();      
      if (this.peoples.length > 0) {
        this.showAddButton = true;
        this.addButtonShow = false;
      } else {
        this.showAddButton = false;
      }
    }else{
      this.addButtonShow = false;
      this.stateCtrl.reset();
    }

  }

  removeContact(item: any) {
    const index = this.peoples.indexOf(item);
    if (index >= 0) {
      this.peoples.splice(index, 1);
    }
    if (this.peoples.length == 0) {
      this.stateCtrl.reset();
      this.showAddButton = false;
    }

  }

  removeDocument(document) {
    const index = this.selectedFileList.indexOf(document);
    if (index >= 0) {
      this.selectedFileList.splice(index, 1);
      if (this.mainModuleName == "Core") {
        this._dataSharingService.sendRemoveFaxDocumentForCore(document);
      }
      if (this.mainModuleName == "Contact") {
        this._dataSharingService.sendRemoveRequestDocumentForContact(document);
      }
      if (this.mainModuleName == "Company") {
        this._dataSharingService.sendRemoveRequestDocumentForCompany(document);
      }
      if (this.mainModuleName == "File Manager") {
        this._dataSharingService.sendRemoveFaxDocumentForFileManager(document);
      }
    }
    if (this.selectedFileList.length == 0) {
      this.showAddButton = false;
      this.closeShareOpt(false);
      if (this.mainModuleName == "Core") {
        this._dataSharingService.sendRemoveFaxDocumentForCore(true);
      }
      if (this.mainModuleName == "Contact") {
        this._dataSharingService.sendClosePanelFromDocDetailsContact(true);
      }
      if (this.mainModuleName == "Company") {
        this._dataSharingService.sendClosePanelFromDocDetailsCompany(true);
      }
      if (this.mainModuleName == "File Manager") {
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    }
  }  

  sendFax() {
    this.showAddButton=false;
    this.spinner=true;
    this.selectedFileList;
    this.peoples;
    this.FileList = [];
    this.UserList = [];
    if (this.selectedFileList.length > 0) {
      this.transactionID = this.selectedFileList[0].transactionID;
      for (let i = 0; i < this.selectedFileList.length; i++) {       
        let file = {
          fileManagerItemID: this.selectedFileList[i].fileManagerItemID,
          fileUrl: this.selectedFileList[i].azureblobPath,
          pages: Number(this.selectedFileList[i].pages),
        }
        this.FileList.push(file);
      }
      this.fileManagerIDs = this.FileList;
    } else {
      this.fileManagerIDs = [];
    }

    if (this.peoples.length > 0) {
      for (let i = 0; i < this.peoples.length; i++) {
        var contactID = this.peoples[i].contactID;
        if (contactID > 0) {
          contactID = this.peoples[i].contactID;
        } else {
          contactID = 0;
        }

        var name = this.peoples[i].name;
        if (name != "" || name != undefined) {
          name = this.peoples[i].name;
        } else {
          name = "";
        }

        var fax = this.peoples[i].fax;
        if (fax != "" || fax != undefined) {
          fax = this.peoples[i].fax;
        } else {
          fax = "";
        }

        var ReqModels = {
          contactID: contactID,
          fax: fax,
          name:name
        }
        this.UserList.push(ReqModels);
      }
      this.contacts = this.UserList;
    } else {
      this.contacts = '';
    }
  
    if(this.subject==null || this.subject==undefined){
      this.subject="";
    }
    if(this.message==null || this.message==undefined){
      this.message="";
    }
    var reqModel = {
      subject: this.subject,
      message: this.message,
      replyFaxNumber: this.replyFaxNumber,
      requestStatus: 0,
      requestType: RequestType.Fax, // 1-Request , 2-Email , 3-Fax
      fileManagerIDs: this.fileManagerIDs,
      contacts: this.contacts,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.settingsService.AddFaxRequest(reqModel).subscribe(response => {
      if (response != undefined) {
        this.showAddButton=true;
        this.spinner=false;
        this.closeShareOpt(false);
        if (response.status == this.statusConst.statusSuccess) {
          this.subject = "";
          this.message = "";
          this.replyFaxNumber = "";
          this.stateCtrlSubject.reset();
          this.MessageTemplateID=0;
          this.toastr.success('Fax request created successfully.', '', {
            timeOut: 3000,
          });        
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
        else {
          this.showAddButton=true;
          this.spinner=false;
          this.subject = "";
          this.message = "";
          this.replyFaxNumber = "";
          this.stateCtrlSubject.reset();
          this.MessageTemplateID=0;
          this.toastr.error('Fax request create failed.', '', {
            timeOut: 3000,
          });
          this.closeShareOpt(false);
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
      } else {
        this.showAddButton=true;
        this.spinner=false;
        this.subject = "";
        this.message = "";
        this.replyFaxNumber = "";
        this.stateCtrlSubject.reset();
        this.MessageTemplateID=0;
        this.toastr.error('Fax request create failed.', '', {
          timeOut: 3000,
        });
        this.closeShareOpt(false);
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    });

  }

  /** Allow only Alphabet */
  allowAlphabetOnly(event) {
		const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {
      //this.titleAlert = 'Please enter only alphabets';
		  event.preventDefault();
		  return false;
		}
  }

  /** Allow only Number */
  allowOnlyNumber(event) {
		const regexp = new RegExp('^([0-9])$');
		const result = regexp.test(event.key);
		if (!result) {
		  event.preventDefault();
		  return false;
		}
  }

  subjectList:any=[];
  ShowSubjectMessageButton:boolean=false;
  SubjectMessageButton:boolean=false;
  MessageTemplateID:number=0;

  searchSubject(val) {   
    if(this.subject!="" && this.message!=""){   
      this.SubjectMessageButton=false;
      if(this.MessageTemplateID>0){
        this.ShowSubjectMessageButton=false;
      }else{
        this.ShowSubjectMessageButton=true;
      }  

      if(val != '' && val.length>2){
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
         this.getSubjectTemplate(val)
        }, 500);
      }
   }else{
     this.ShowSubjectMessageButton=false;
     this.SubjectMessageButton=false;
     this.subjectList=[];
     if(val != '' && val.length>2){
     clearTimeout(this.timeout)
     this.timeout = setTimeout(() => {
      this.getSubjectTemplate(val)
     }, 500);
   }else{
     this.subjectList=[];
    }
   }  
  }

  CheckMessage(val) {
    if(this.subject==null || this.subject==undefined){
      this.subject="";
    }
    if(this.subject!="" && this.message!=""){
      if(this.MessageTemplateID>0){
        this.ShowSubjectMessageButton=false;
      }else{
        this.ShowSubjectMessageButton=true;
      }       
    }else{
      this.ShowSubjectMessageButton=false;
    }
  }

  getSubjectTemplate(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      SearchKey: searchValue,
      officeID:this.myOfficeID
    }
    this.spinnerTemp=false;
    this.settingsService.SearchSubjectTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.subjectList = response.data;
          if(this.subject!="" && this.message!=""){
            this.ShowSubjectMessageButton=true;
         }else{
           this.ShowSubjectMessageButton=false;
         }
        }else{
          this.subjectList=[];
          this.MessageTemplateID=0;
          if(this.subject!="" && this.message!=""){
            this.ShowSubjectMessageButton=true;
         }else{
           this.ShowSubjectMessageButton=false;
         }
        }
       }else{
         this.subjectList=[];
         this.MessageTemplateID=0;
         if(this.subject!="" && this.message!=""){
          this.ShowSubjectMessageButton=true;
       }else{
         this.ShowSubjectMessageButton=false;
       }
       }
     }  
    )
  }

  subjectSelected(subject: any) {  
    if(subject.messageTemplateID>0){
      this.message= subject.message;
      this.subject= subject.subject;
      this.ShowSubjectMessageButton=false;
      this.MessageTemplateID=subject.messageTemplateID;
    }else{
      this.MessageTemplateID=0;
      this.ShowSubjectMessageButton=false;
    }
  }

  onEnterSubject(event,subject) {
    var findSubject =[];
    findSubject = this.subjectList.filter((x) => x.subject === event.target.value);
    if(findSubject.length>0){
      this.message= findSubject[0].message;
      this.subject= findSubject[0].subject;
      this.ShowSubjectMessageButton=false;
      this.MessageTemplateID=findSubject[0].messageTemplateID;
    }
  }
  
  AddSubjectMessageTemplate() {
     this.subject = this.stateCtrlSubject.value;
      var ReqModel = {
        messageTemplateID:0,
        typeID:MessageTemplate.Fax,  // 1-Brodcast , 2-Request , 3-Fax , 4-Project  
        subject: this.subject,
        message: this.message,
        UserID: this.currentUser.UID,
        organizationID: Number(this.organizationId),      
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList
      }
      this.spinnerTemp=true;
      this.SubjectMessageButton=true;
      this.settingsService.AddUpdateSubjectMessageTemplate(ReqModel).subscribe(response => {
        if (response.status == this.statusConst.statusSuccess) {
          this.ShowSubjectMessageButton=false;
          this.SubjectMessageButton=false;
          this.spinnerTemp=false;
        }
      });
   }







  // sendRequestForContact() {
  //   this.selectedFileList;
  //   this.peoples;
  //   this.FileList = [];
  //   this.UserList = [];
  //   if (this.selectedFileList.length > 0) {
  //     for (let i = 0; i < this.selectedFileList.length; i++) {
  //       this.FileList.push(this.selectedFileList[i].placeholderID);
  //     }
  //     this.fileManagerIDs = this.FileList.join(',');
  //   } else {
  //     this.fileManagerIDs = '';
  //   }

  //   if (this.peoples.length > 0) {
  //     for (let i = 0; i < this.peoples.length; i++) {
  //       var contactID = this.peoples[i].contactID;
  //       if (contactID > 0) {
  //         contactID = this.peoples[i].contactID;
  //       } else {
  //         contactID = 0;
  //       }

  //       var fax = this.peoples[i].fax;
  //       if (fax != "" || fax != undefined) {
  //         fax = this.peoples[i].fax;
  //       } else {
  //         fax = "";
  //       }
  //       var obj = {
  //         contactID: contactID,
  //         fax: fax
  //       }
  //       this.UserList.push(obj);
  //     }
  //     this.contacts = this.UserList;
  //   } else {
  //     this.contacts = '';
  //   }

  //   let date = new Date()
  //   date.setDate(date.getDate() + 30);

  //   var ReqModel = {
  //     subject: this.subject,
  //     message: this.message,
  //     replyFaxNumber: this.replyFaxNumber,
  //     requestStatus: 0,
  //     requestExpiryDate: date,
  //     requestType: 1, //Request-1,Email-2,Fax-3
  //     fileManagerIDs: this.fileManagerIDs,
  //     contacts: this.contacts,
  //     requestPassword: "",
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //   }
  //   this.closeShareOpt(false);
  //   this.settingsService.AddRequestFromCore(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       if (response.status == this.statusConst.statusSuccess) {
  //         this.subject = "";
  //         this.message = "";
  //         this.replyFaxNumber = "";
  //         this.toastr.success('Request created successfully.', '', {
  //           timeOut: 3000,
  //         });
  //         this.closeShareOpt(false);
  //         this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
  //       }
  //       else {
  //         this.subject = "";
  //         this.message = "";
  //         this.replyFaxNumber = "";
  //         this.toastr.error('Request create failed.', '', {
  //           timeOut: 3000,
  //         });
  //         this.closeShareOpt(false);
  //         this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
  //       }
  //     } else {
  //       this.subject = "";
  //       this.message = "";
  //       this.replyFaxNumber = "";
  //       this.toastr.error('Request create failed.', '', {
  //         timeOut: 3000,
  //       });
  //       this.closeShareOpt(false);
  //       this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
  //     }
  //   });

  // }

  // sendRequestForCompany() {
  //   this.selectedFileList;
  //   this.peoples;
  //   this.FileList = [];
  //   this.UserList = [];
  //   if (this.selectedFileList.length > 0) {
  //     for (let i = 0; i < this.selectedFileList.length; i++) {
  //       this.FileList.push(this.selectedFileList[i].placeholderID);
  //     }
  //     this.fileManagerIDs = this.FileList.join(',');
  //   } else {
  //     this.fileManagerIDs = '';
  //   }

  //   if (this.peoples.length > 0) {
  //     for (let i = 0; i < this.peoples.length; i++) {
  //       var contactID = this.peoples[i].contactID;
  //       if (contactID > 0) {
  //         contactID = this.peoples[i].contactID;
  //       } else {
  //         contactID = 0;
  //       }

  //       var fax = this.peoples[i].fax;
  //       if (fax != "" || fax != undefined) {
  //         fax = this.peoples[i].fax;
  //       } else {
  //         fax = "";
  //       }
  //       var obj = {
  //         contactID: contactID,
  //         fax: fax
  //       }
  //       this.UserList.push(obj);
  //     }
  //     this.contacts = this.UserList;
  //   } else {
  //     this.contacts = '';
  //   }

  //   let date = new Date()
  //   date.setDate(date.getDate() + 30);

  //   var ReqModel = {
  //     subject: this.subject,
  //     message: this.message,
  //     replyFaxNumber: this.replyFaxNumber,
  //     requestStatus: 0,
  //     requestExpiryDate: date,
  //     requestType: 1, //Request-1,Email-2,Fax-3
  //     fileManagerIDs: this.fileManagerIDs,
  //     contacts: this.contacts,
  //     requestPassword: "",
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //   }
  //   this.closeShareOpt(false);
  //   this.settingsService.AddRequestFromCore(ReqModel).subscribe(response => {
  //     if (response != undefined) {
  //       if (response.status == this.statusConst.statusSuccess) {
  //         this.subject = "";
  //         this.message = "";
  //         this.replyFaxNumber = "";
  //         this.toastr.success('Request created successfully.', '', {
  //           timeOut: 3000,
  //         });
  //         this.closeShareOpt(false);
  //         this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
  //       }
  //       else {
  //         this.subject = "";
  //         this.message = "";
  //         this.replyFaxNumber = "";
  //         this.toastr.error('Request create failed.', '', {
  //           timeOut: 3000,
  //         });
  //         this.closeShareOpt(false);
  //         this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
  //       }
  //     } else {
  //       this.subject = "";
  //       this.message = "";
  //       this.replyFaxNumber = "";
  //       this.toastr.error('Request create failed.', '', {
  //         timeOut: 3000,
  //       });
  //       this.closeShareOpt(false);
  //       this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
  //     }
  //   });

  // }

}
